import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import {
    AccountService,
    AuthServerProvider,
    AuthService,
    CSRFService,
    HasNoneAuthoritiesDirective,
    HasAnyAuthorityDirective,
    HasAuthorityDirective,
    JhiLoginModalComponent,
    LoginModalService,
    LoginService,
    PlatonSharedCommonModule,
    PlatonSharedLibsModule,
    Principal,
    StateStorageService,
} from './';
import { LoadingComponent } from './loading/loading.component';
import { FeatureFlagsService } from './auth/feature-flags.service';

@NgModule({
    imports: [PlatonSharedLibsModule, PlatonSharedCommonModule],
    declarations: [
        JhiLoginModalComponent,
        HasAuthorityDirective,
        HasAnyAuthorityDirective,
        HasNoneAuthoritiesDirective,
        LoadingComponent,
    ],
    providers: [
        CookieService,
        LoginService,
        LoginModalService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        AuthServerProvider,
        AuthService,
        FeatureFlagsService,
        DatePipe,
    ],
    entryComponents: [JhiLoginModalComponent],
    exports: [
        PlatonSharedCommonModule,
        JhiLoginModalComponent,
        HasAuthorityDirective,
        HasAnyAuthorityDirective,
        HasNoneAuthoritiesDirective,
        DatePipe,
        LoadingComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlatonSharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts